import { DialogActions, DialogContent, OutlinedInput } from "@material-ui/core";
import { closeModal } from "actions/modalActions";
import { payrollUpdateReportRecord } from "actions/payrollAction";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { useModalStyles } from "../styles";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { PayrollRowData } from "types/Payroll";

export const EditPayrollNoteModalContent: FC<{ report: PayrollRowData }> = ({ report }) => {
  const dispatch = useDispatch();
  const classes = useModalStyles();
  const [value, setValue] = useState(report.comment || "");

  useEffect(() => {
    setValue(report.comment || "");
  }, [report.comment]);

  const onClose = () => dispatch(closeModal());
  const handleSubmit = () => {
    dispatch(payrollUpdateReportRecord(report.date, value, report.user_id, report.station_id));
    onClose();
  };

  return (
    <>
      <DialogContent style={{ marginBottom: 16 }}>
        <OutlinedInput
          fullWidth
          multiline
          defaultValue={value}
          onChange={(e) => setValue(e.target.value)}
          minRows={6}
          maxRows={6}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <CustomButton buttonText={"Cancel"} onClick={onClose} variant="text" />
        <CustomButton
          buttonText={"Save"}
          onClick={handleSubmit}
          variant="contained"
          disabled={value === (report.comment || "")}
        />
      </DialogActions>
    </>
  );
};
